import { PartialNullable } from "../Extensions";
import { PropertyChange } from "../PropertyChange";
import { Property, PropertyBoolean, PropertyObject, PropertyString } from "../RadObject";
import { Expression, ExpressionPropertyValues, IExpression } from "./Expression";
import { NAMESPACE } from "./_Namespace";

export enum ComparisonExpressionOperatorEnum
{
    contains = "contains",
    equals = "equals",
    greaterThan = "greaterThan",
    greaterThanOrEqualTo = "greaterThanOrEqualTo",
    lessThan = "lessThan",
    lessThanOrEqualTo = "lessThanOrEqualTo",
    notEqualTo = "notEqualTo",
}

export type ComparisonExpressionPropertyValues =
    ExpressionPropertyValues
    & {
        operator: ComparisonExpressionOperatorEnum;
        path: string;
        value: any;
    };

export type ComparisonExpressionProperties = {
    [name in keyof ComparisonExpressionPropertyValues]: Property<ComparisonExpressionPropertyValues[name]>
};

export interface IComparisonExpression extends IExpression, ComparisonExpressionProperties
{
}

export class ComparisonExpression extends Expression<ComparisonExpressionPropertyValues> implements IComparisonExpression
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ComparisonExpression";
    public static override className = "ComparisonExpression";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ComparisonExpressionPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                operator: ComparisonExpressionOperatorEnum.equals,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public operator!: Property<ComparisonExpressionOperatorEnum>;
    public path!: PropertyString;
    public value!: PropertyObject;

    // #endregion

    // #region Protected Methods

    protected _operatorChanged(change: PropertyChange<ComparisonExpressionOperatorEnum>)
    {
        /* Intentionally empty */
    }
    protected _pathChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }
    protected _valueChanged(change: PropertyChange<any>)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: ComparisonExpressionPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.operator = new Property<ComparisonExpressionOperatorEnum>(this, "System.String, System.Private.CoreLib", propertyValues.operator, this._operatorChanged);
        this.path = new PropertyString(this, propertyValues.path, this._pathChanged);
        this.value = new PropertyObject(this, propertyValues.value, this._valueChanged);
    }

    // #endregion

    // #endregion
}
